module.exports = __webpack_public_path__ + "img/2D-Cave2.45e05546.png";